// Keyboard Shortcuts First-Time Hint
import { useEffect, useState } from 'react';
import { X } from 'lucide-react';

const STORAGE_KEY = 'gmc_shortcuts_hint_dismissed';

export default function KeyboardShortcutsHint() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Check if user has seen this hint before
    const dismissed = localStorage.getItem(STORAGE_KEY);
    if (!dismissed) {
      // Show hint after 2 seconds (let user settle in)
      const timer = setTimeout(() => setVisible(true), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div 
      className="fixed bottom-24 right-6 z-50 animate-fade-slide-in"
      style={{ animationDelay: '0.2s' }}
    >
      <div 
        className="relative px-4 py-3 rounded-xl border max-w-xs"
        style={{ 
          background: 'rgba(22, 25, 34, 0.95)',
          borderColor: 'rgba(196,181,253,0.3)',
        }}
      >
        {/* Close button */}
        <button
          onClick={handleDismiss}
          className="absolute -top-2 -right-2 w-6 h-6 rounded-full flex items-center justify-center transition-all cursor-pointer"
          style={{ 
            background: 'rgba(196,181,253,0.2)',
            color: 'var(--calm)',
          }}
          onMouseEnter={e => e.currentTarget.style.background = 'rgba(196,181,253,0.3)'}
          onMouseLeave={e => e.currentTarget.style.background = 'rgba(196,181,253,0.2)'}
        >
          <X className="w-3.5 h-3.5" />
        </button>

        {/* Content */}
        <div className="flex items-start gap-3">
          <div className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0" style={{ background: 'rgba(196,181,253,0.15)' }}>
            <span className="text-lg">⌨️</span>
          </div>
          <div className="flex-1">
            <p className="text-sm font-semibold mb-1" style={{ color: 'var(--text-primary)' }}>
              Klavye Kısayolları
            </p>
            <p className="text-xs mb-2" style={{ color: 'var(--text-2)' }}>
              Hızlı erişim için klavye kısayollarını kullanabilirsiniz
            </p>
            <button
              onClick={handleDismiss}
              className="kbd text-[10px] px-2 py-1"
            >
              ?
            </button>
            <span className="text-[10px] ml-2" style={{ color: 'var(--text-3)' }}>
              tuşuna basın
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
